import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import '@/assets/css/public.css'
import '@/assets/css/common.less'

import echarts from 'echarts/lib/echarts'

import china from 'echarts/map/json/china.json'

echarts.registerMap('china', china)

Vue.use(ElementUI)
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
